import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { ReadMore as ReadMoreIcon } from "@mui/icons-material";

export const LoadNextButton = ({ onClick, isFetchingNextPage, hasNextPage, t, loadNextIsDisabled }) => (
  <Box display={"flex"} justifyContent={"center"} my={2}>
    {hasNextPage && (
      <Button
        startIcon={!isFetchingNextPage && <ReadMoreIcon />}
        data-testid="load-more-button"
        data-ym={"LOAD_MORE"}
        color={"primary"}
        sx={{ borderRadius: 3 }}
        variant={"outlined"}
        onClick={onClick}
        disabled={loadNextIsDisabled}
      >
        {isFetchingNextPage ? (
          <>
            &nbsp;
            <CircularProgress color={"inherit"} size={20} />
            &nbsp;
          </>
        ) : hasNextPage ? (
          t("cta-load-more")
        ) : (
          t("cta-load-more-ended")
        )}
      </Button>
    )}
  </Box>
);
